import { get } from 'lodash-es';
import * as location from '../utils/location';
export function getPathnameFromState(state) {
    var _a = getLocationState(state), projectID = _a.projectID, sectionID = _a.sectionID, screenID = _a.screenID, hotspotID = _a.hotspotID, isHandoff = _a.isHandoff, showScreens = _a.showScreens;
    return location.getPathName(projectID, showScreens, sectionID, screenID, hotspotID, false, isHandoff);
}
export function getLocationState(state) {
    var projectID = get(state, 'project.config.id');
    var sectionID = get(state, 'project.sectionID');
    var screenID = get(state, 'screen.currentScreen.id');
    var hotspotID = get(state, 'screen.currentOverlayHotspot.id', null);
    var isHandoff = get(state, 'handoff.isOpen');
    var showScreens = get(state, 'grid.isOpen');
    return {
        projectID: projectID,
        sectionID: sectionID,
        screenID: screenID,
        hotspotID: hotspotID,
        isHandoff: isHandoff,
        showScreens: showScreens,
    };
}
